import React, { useEffect } from "react";

export default function ViewModal({ open, title, children, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        className="card shadow"
        style={{
          width: "min(920px, 100%)",
          maxHeight: "85vh",
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="card-header d-flex justify-content-between align-items-center"
          style={{ background: "#111", color: "#fff" }}
        >
          <div style={{ fontWeight: 700 }}>{title}</div>
          <button className="btn btn-sm btn-outline-light" onClick={onClose}>
            Close
          </button>
        </div>
        <div
          className="card-body"
          style={{
            background: "#fff",
            color: "#111",
            overflowY: "auto",
            maxHeight: "calc(85vh - 56px)",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

